/**
 * RelivConferenceTicketItemConverter
 * @param relivConferenceModelFactory
 * @constructor
 */
var RelivConferenceTicketItemConverter = function (relivConferenceModelFactory) {
    /**
     * self
     */
    var self = this;

    /**
     * updateOrderItems
     * @param orderItems
     * @param ticketItemArray
     * @returns {Array|*}
     */
    self.updateOrderItems = function (
        orderItems,
        ticketItemArray
    ) {
        var ticketItems = self.indexTicketItemArray(ticketItemArray);

        if (orderItems == undefined || typeof orderItems !== 'object') {
            orderItems = [];
        }

        var conferenceOrderItems = self.convertToOrderItems(ticketItems);

        orderItems = self.removeConferenceOrderItems(orderItems);

        angular.forEach(
            conferenceOrderItems,
            function (conferenceOrderItem, key) {
                orderItems = self.updateOrderItem(conferenceOrderItem, orderItems);
            }
        );

        return orderItems;
    };

    /**
     * getTicketItemIndex
     * @param ticketItemArray
     * @returns {{key : uid}}
     */
    self.indexTicketItemArray = function (ticketItemArray) {
        var ticketItems = {};
        angular.forEach(
            ticketItemArray,
            function (ticketItem, key) {
                ticketItems[ticketItem.uid] = ticketItem;
            }
        );

        return ticketItems;

    };

    /**
     * removeConferenceOrderItems
     * @param orderItems
     * @param conferenceId
     * @returns {Array}
     */
    self.removeConferenceOrderItems = function (orderItems) {

        var otherOrderItems = [];

        angular.forEach(
            orderItems,
            function (orderItem, key) {
                if (!self.isConferenceOrderItem(orderItem)) {
                    otherOrderItems.push(angular.copy(orderItem));
                }
            }
        );

        return otherOrderItems;
    };

    /**
     * updateOrderItem
     * @param conferenceOrderItem
     * @param orderItems
     */
    self.updateOrderItem = function (conferenceOrderItem, orderItems) {
        for (var i = 0; i < orderItems.length; i++) {
            var orderItem = angular.copy(orderItems[i]);

            if (self.orderItemsMatch(conferenceOrderItem, orderItem)) {
                orderItem.data = orderItem.data.concat(conferenceOrderItem.data);
                orderItem.qty = orderItem.data.length;
                orderItem.skuNumber = orderItem.data[0].skuNumber;

                orderItems[i] = orderItem;
                return orderItems;
            }
        }

        orderItems.push(conferenceOrderItem);

        return orderItems;
    };

    /**
     * orderItemsMatch
     * @param orderItem1
     * @param orderItem2
     * @returns {boolean}
     */
    self.orderItemsMatch = function (orderItem1, orderItem2) {

        if (orderItem1.skuNumber != orderItem2.skuNumber) {
            return false;
        }

        return (orderItem1.type == orderItem2.type);
    };

    /**
     * isConferenceOrderItem
     * @param orderItem
     * @returns {boolean}
     */
    self.isConferenceOrderItem = function (orderItem) {

        // must be correct type
        if (orderItem.type != 'conferenceTicket' && orderItem.type != 'conferenceFeature') {
            return false;
        }
        // existing will have data
        return Boolean(orderItem.data);
    };

    /**
     * convertToOrderItems
     * @param ticketItems
     */
    self.convertToOrderItems = function (
        ticketItems
    ) {

        var conferenceOrderItems = [];

        angular.forEach(
            ticketItems,
            function (ticketItem, key) {
                var ticketOrderItem = relivConferenceModelFactory.newOrderItem();
                ticketOrderItem.skuNumber = ticketItem.skuNumber;
                ticketOrderItem.qty = 1;
                ticketOrderItem.qtyIsLocked = true;
                ticketOrderItem.type = 'conferenceTicket';
                ticketOrderItem.data = [angular.copy(ticketItem)];

                conferenceOrderItems.push(ticketOrderItem);

                conferenceOrderItems = self.buildFeatureOrderItems(
                    ticketItem,
                    conferenceOrderItems
                );
            }
        );

        return conferenceOrderItems;
    };

    /**
     * buildFeatureOrderItems
     * @param ticketItem
     * @param conferenceOrderItems
     * @returns {*}
     */
    self.buildFeatureOrderItems = function (
        ticketItem,
        conferenceOrderItems
    ) {

        if (conferenceOrderItems == undefined || typeof conferenceOrderItems !== 'object') {
            conferenceOrderItems = [];
        }

        return self.buildFeatureOrderItemsFromFeatureArray(ticketItem, ticketItem.featureData, conferenceOrderItems);
    };

    /**
     *
     * @param {*} ticketItem
     * @param {Array} features
     * @param {Array} featureOrderItems
     * @returns {Array}
     */
    self.buildFeatureOrderItemsFromFeatureArray = function (ticketItem, features, featureOrderItems) {

        if (featureOrderItems == undefined || typeof featureOrderItems !== 'object') {
            featureOrderItems = [];
        }

        var featureOrderItemsIndex = {};
        var featureOrderItem = null;
        var featureData = null;
        for (var i = 0; i < features.length; i++) {
            featureData = features[i];
            if (featureData.skuNumber === null) {
                continue;
            }
            featureOrderItem = self.buildFeatureOrderItem(
                ticketItem,
                featureData
            );
            if (featureOrderItemsIndex[featureData.skuNumber]) {
                featureOrderItemsIndex[featureData.skuNumber].qty++;
                featureOrderItemsIndex[featureData.skuNumber].data.push(featureOrderItem.data[0]);
                continue;
            }
            featureOrderItemsIndex[featureData.skuNumber] = featureOrderItem;
        }

        for (var featureOrderItemSku in featureOrderItemsIndex) {
            featureOrderItems.push(featureOrderItemsIndex[featureOrderItemSku]);
        }

        return featureOrderItems;
    };

    /**
     * buildFeatureOrderItem
     * @param ticketItem
     * @param featureData
     * @returns {RelivConferenceOrderItem}
     */
    self.buildFeatureOrderItem = function (
        ticketItem,
        featureData
    ) {
        var featureOrderItem = relivConferenceModelFactory.newOrderItem();

        featureData.ticketUid = ticketItem.uid;
        featureData.conferenceId = ticketItem.conferenceId;

        featureOrderItem.data = [
            featureData,
        ];
        featureOrderItem.skuNumber = featureData.skuNumber;
        featureOrderItem.type = 'conferenceFeature';
        featureOrderItem.qty = 1;
        featureOrderItem.qtyIsLocked = true;

        return featureOrderItem;
    };
};

/**
 * relivConference.relivConferenceTicketItemConverter
 */
angular.module('relivConference').service(
    'relivConferenceTicketItemConverter',
    [
        'relivConferenceModelFactory',
        function (relivConferenceModelFactory) {
            return new RelivConferenceTicketItemConverter(relivConferenceModelFactory);
        },
    ]
);
